import "./widget_core.js"
import "../../../public/javascripts/backbone/lib/concerns/views/header_helpers.js"
var req = require.context('../../../public/javascripts/backbone/apps/photowall_mobile/', true, /\.js$/)
req.keys().forEach(req)
